import { render, staticRenderFns } from "./ContattoList.vue?vue&type=template&id=28d0787f&scoped=true&"
import script from "./ContattoList.vue?vue&type=script&lang=ts&"
export * from "./ContattoList.vue?vue&type=script&lang=ts&"
import style0 from "./ContattoList.vue?vue&type=style&index=0&id=28d0787f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d0787f",
  null
  
)

export default component.exports